import $ from 'jquery';

export default function slick() {
  
  function slider() {
    $('#slider').slick({
      autoplay: true,
      autoplaySpeed: 8000,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  function centerSlider() {
    $('.center-slider').slick({
      centerMode: true,
      infinite: true,
      dots: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992, //tablet
          settings: {
            centerMode: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768, //phone
          settings: {
            centerMode: false,
            slidesToShow: 1
          }
        }
      ]
    });
  }
  
  function eventSlider() {
    $('#event-slider').slick({
      autoplay: true,
      autoplaySpeed: 8000,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  function photogallerySlider() {
    $('#photogallery-slider').slick({
      autoplay: false,
      autoplaySpeed: 8000,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 992, //tablet
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 768, //phone
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
  
  function camereDoppieSlider() {
    $('#dettaglio-slider-1').slick({
      autoplay: false,
      autoplaySpeed: 8000,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  function camereTripleSlider() {
    $('#dettaglio-slider-2').slick({
      autoplay: false,
      autoplaySpeed: 8000,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  function attivitaSlider() {
    $('#attivita-slider').slick({
      autoplay: false,
      autoplaySpeed: 8000,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-chevron-right"></i></button>',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  $( document ).ready(function() {
    if($('.center-slider').length > 0) {
      centerSlider();
    }
    
    if($('#slider').length > 0) {
      slider();
    }
    
    if($('#event-slider').length > 0) {
      eventSlider();
    }
    
    if($('#photogallery-slider').length > 0) {
      photogallerySlider();
    }
    
     if($('#dettaglio-slider-1').length > 0) {
      camereDoppieSlider();
    }
    
    if($('#dettaglio-slider-2').length > 0) {
      camereTripleSlider();
    }
    
    if($('#attivita-slider').length > 0) {
      attivitaSlider();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/slider-slick.js